import React from 'react'
import { getMediaTypeById } from '../../../utils/mediaTypes'
import { getSubindustryById, getIndustryBySubIndustryId } from '../../../utils/industries'
import getAspectRatioLabel from '../../../utils/videoAspectRatios'
import flowsamLogo from '../../../assets/images/flowsam-logo.svg'
import styles from'./styles.module.css'

// component function
export default function ReportHeader(props) {

	const { video } = props

	// find media type & icon by targetPlatform id
	const mediaType = getMediaTypeById(video.targetPlatform)
	const mediaTypeLabel = mediaType?.label || 'n/a'
	const mediaTypeIcon = video.targetPlatform > 0 && (require('../../../assets/images/media-type-icons/' + mediaType?.icon) || null)
	const industryIcon = video.industrySubCode > 0 && (require('../../../assets/images/industry-icons/' + getIndustryBySubIndustryId(video.industrySubCode)?.icon) || null)

	// analysis update date
	const dateOptions = { year:'numeric', month:'short', day:'numeric', hour:'numeric', minute:'numeric' }
	const date = video?.updatedAt ? new Date(video.updatedAt).toLocaleDateString("en-GB", dateOptions) : null

	// video duration string
	const secs = video.analysisType !== 3 ? Math.round(video.frameCount/video.frameRate) : 0
	const timestring = new Date(secs * 1000).toISOString()
	const durationString = secs > 3600 ? timestring.substring(12, 19) : secs > 600 ? timestring.substring(14, 19) : timestring.substring(15, 19)

	// video duration
	const duration = (video.analysisType !== 3 && // not still image
		<div className={styles.detail + ' ' + styles.detailSmall}>
			<div className={styles.detailLabel}>Duration</div>
			<div className={styles.detailText}>{durationString}</div>
		</div>
	)

	const format = video.analysisType === 3 ? 'Image' : getAspectRatioLabel(video.width/video.height) + ' video'

	return (
		<div className={styles.background}>
			<div className={styles.header}>
			<div className={styles.heading}>Ad strength report</div>
				<img src={flowsamLogo} className={styles.logo} alt="Flowsam logo" />
			</div>
			<div className={styles.analysisTitle}>{video.title}</div>
			<div className={styles.analysisProject}>{video.project?.name}</div>
			<div className={styles.detailsWrapper}>
				<div className={styles.detailsGroupWrapper}>
					<div className={styles.detail}>
						<div className={styles.detailLabel}>Analysis completed</div>
						<div className={styles.detailText}>{date}</div>
					</div>
					<div className={styles.detail}>
						<div className={styles.detailLabel}>Brand</div>
						<div className={styles.detailText}>{video.brand?.name}</div>
					</div>
					<div className={styles.detail}>
						<div className={styles.detailLabel}>Sub brand</div>
						<div className={styles.detailText}>{video.subbrand === 'NULL' || video.subbrand === '' ? '\u00A0' : video.subbrand}</div>
					</div>
				</div>
				<div className={styles.detailsGroupWrapper}>
					<div className={styles.detail + ' ' + (mediaTypeIcon && styles.mediaTypeIcon)} style={{ backgroundImage:'url(' + mediaTypeIcon + ')' }}>
						<div className={styles.detailLabel}>Media type</div>
						<div className={styles.detailText}>{mediaTypeLabel}</div>
					</div>
					<div className={styles.detail + ' ' + (industryIcon && styles.industryIcon)} style={{ backgroundImage:'url(' + industryIcon + ')' }}>
						<div className={styles.detailLabel}>{getIndustryBySubIndustryId(video.industrySubCode)?.label || 'Industry'}</div>
						<div className={styles.detailText}>{getSubindustryById(video.industrySubCode)?.label || '\u00A0'}</div>
					</div>
					{/*<div className={styles.detail}>
						<div className={styles.detailLabel}>Sub-industry</div>
						<div className={styles.detailText}>{getSubindustryById(video.industrySubCode)?.label || '\u00A0'}</div>
					</div>*/}
					<div className={styles.detail}>
						<div className={styles.detailLabel}>Analysis type</div>
						<div className={styles.detailText}>{video.ownanalysis === 0 ? 'Competitor ad' : 'Own ad'}</div>
					</div>
				</div>
				<div className={styles.detailsGroupWrapper}>
					<div className={styles.detailSubgroupWrapper}>
						<div className={styles.detail + ' ' + styles.detailSmall}>
							<div className={styles.detailLabel}>Version</div>
							<div className={styles.detailText}>{video.version === 'NULL' || video.version === '' ? '\u00A0' : video.version}</div>
						</div>
						<div className={styles.detail + ' ' + styles.detailSmall}>
							<div className={styles.detailLabel}>Format</div>
							<div className={styles.detailText}>{format}</div>
						</div>
						{duration}
					</div>
					<div className={styles.detail}>
						<div className={styles.detailLabel}>Comments</div>
						<div className={styles.commentsText}>{video.comments === 'NULL' || video.comments === '' ? '\u00A0' : video.comments}</div>
					</div>
				</div>
			</div>
			<div className={styles.fileName}>File name: {video.filename}</div>
		</div>
	)
}
